var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "components-input-demo-presuffix" },
    [
      _c(
        "a-input",
        {
          attrs: {
            placeholder: "请点击选择部门",
            readOnly: "",
            disabled: _vm.disabled,
          },
          on: { click: _vm.openModal },
          model: {
            value: _vm.departNames,
            callback: function ($$v) {
              _vm.departNames = $$v
            },
            expression: "departNames",
          },
        },
        [
          _c("a-icon", {
            attrs: { slot: "prefix", type: "cluster", title: "部门选择控件" },
            slot: "prefix",
          }),
          _vm.departIds
            ? _c("a-icon", {
                attrs: { slot: "suffix", type: "close-circle", title: "清空" },
                on: { click: _vm.handleEmpty },
                slot: "suffix",
              })
            : _vm._e(),
        ],
        1
      ),
      _c("j-select-depart-modal", {
        ref: "innerDepartSelectModal",
        attrs: {
          "modal-width": _vm.modalWidth,
          multi: _vm.multi,
          rootOpened: _vm.rootOpened,
          "depart-id": _vm.departIds,
        },
        on: { ok: _vm.handleOK, initComp: _vm.initComp },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }